import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { Stage, Layer, Group, Line } from 'react-konva';
import { v4 as uuidV4 } from 'uuid';

// grabs pointer position and return it's [x,y] position
const parsePoint = stage => {
  // retrieve the new point to draw from the pointer position
  const newPoint = stage.getStage().getPointerPosition();
  return [newPoint.x, newPoint.y];
};
class Signature extends Component {
  constructor(props) {
    super(props);
    this.handleGestureStart = this.handleGestureStart.bind(this);
    this.handleGestureMove = this.handleGestureMove.bind(this);
    this.handleGestureStop = this.handleGestureStop.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.state = {
      line: [],
      signatureFragments: []
    };
  }
  handleGestureStart() {
    // add line a line, no need to pass in lines, always a new line on start
    this.setState({
      line: [...[], ...parsePoint(this.stage)]
    });
  }
  handleGestureMove() {
    const {
      line
    } = this.state;
    // if there are no previous points on the line, drawing has not begun
    if (line.length) {
      // add the new point
      this.setState({
        line: [...line, ...parsePoint(this.stage)]
      });
    }
  }
  handleGestureStop() {
    const {
      line,
      signatureFragments
    } = this.state;

    // if a line is being drawn... Add the line to the inkAnnotation array
    if (line.length) {
      // add the last point to the line array
      const finalLine = [...line, ...parsePoint(this.stage)];
      // save the new line
      signatureFragments.push(finalLine);
      this.setState({
        line: [],
        // clear the line array
        signatureFragments
      }, () => {
        this.handleChange();
      });
    }
  }
  handleChange() {
    const {
      onChange
    } = this.props;
    // convert the stage to a data url
    const data = this.stage.toDataURL();
    onChange(data);
  }
  handleClear() {
    const {
      onChange
    } = this.props;
    onChange(null);
    this.setState({
      line: [],
      signatureFragments: []
    });
  }
  render() {
    const canvasHeight = 172;
    const canvasWidth = 656;
    const {
      loading,
      disabled,
      hasAppliedSignature
    } = this.props;
    const {
      line,
      signatureFragments
    } = this.state;
    // A signature applied from outside the canvas is still the caller's to clear, even though
    // the canvas drew none of it.
    const isEmpty = signatureFragments.length === 0 && !hasAppliedSignature;
    const isClearDisabled = isEmpty || loading || disabled;

    // This controls an overlay that makes the konva layer not interactable
    const disabledStyles = {
      position: 'absolute',
      height: canvasHeight,
      width: canvasWidth,
      zIndex: 999
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "signature-form"
    }, disabled && /*#__PURE__*/React.createElement("div", {
      className: "disabled",
      style: disabledStyles
    }), /*#__PURE__*/React.createElement(Stage, {
      width: canvasWidth,
      height: canvasHeight,
      ref: node => {
        this.stage = node;
      },
      onMouseDown: this.handleGestureStart,
      onMouseMove: this.handleGestureMove,
      onMouseUp: this.handleGestureStop,
      onMouseOut: this.handleGestureStop // stops drawing when mouse leaves element
      ,
      onTouchStart: this.handleGestureStart,
      onTouchMove: this.handleGestureMove,
      onTouchEnd: this.handleGestureStop,
      className: "signature-input"
    }, /*#__PURE__*/React.createElement(Layer, null, /*#__PURE__*/React.createElement(Group, null, line.length ? /*#__PURE__*/React.createElement(Line, {
      key: uuidV4(),
      points: line,
      stroke: "rgba(0,0,0,1)",
      strokeWidth: 2
    }) : null, signatureFragments.map(lineAnnotation => /*#__PURE__*/React.createElement(Line, {
      key: uuidV4(),
      points: lineAnnotation,
      stroke: "rgba(0,0,0,1)",
      lineCap: "round",
      lineJoin: "round",
      bezier: true,
      strokeWidth: 2
    }))))), /*#__PURE__*/React.createElement(Button, {
      disabled: isClearDisabled,
      onClick: this.handleClear,
      className: "t-s-clear-signature"
    }, "Clear Signature ", loading ? /*#__PURE__*/React.createElement("div", {
      className: "miniLoader float-right",
      style: {
        marginLeft: 5
      }
    }) : null));
  }
}
Signature.propTypes = {
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hasAppliedSignature: PropTypes.bool
};
Signature.defaultProps = {
  loading: false,
  disabled: false,
  hasAppliedSignature: false
};
export default Signature;